import colors from '../../config/colors';

export const styles = {
    displayCardHeader: {
        backgroundColor: "#1a3328",
        color: "#ffffff",
        borderRadius: "10px 10px 0 0",
        padding: "0.85rem 1.25rem",
    },
    displaySearchContainerCardHeader: {
        backgroundColor: "#1a3328",
        color: "#ffffff",
        borderRadius: "10px 10px 0 0",
        padding: "0.85rem 1.25rem",
        textAlign: "center",
    },
    badgePill: {
        marginLeft: "0.5rem",
        backgroundColor: "rgba(255,255,255,0.18)",
        color: "#ffffff",
        fontSize: "0.72rem",
        fontWeight: 700,
    },
    searchCardBody: {
        maxHeight: "80rem",
        overflowY: "auto",
    },
    searchRow: {
        border: "1px solid #c6deca",
        borderRadius: 6,
        marginBottom: "0.5rem",
        textAlign: "center",
        padding: "0.35rem 0",
        backgroundColor: "#f8faf8",
    },
    status: {
        fontSize: '0.7rem',
        fontWeight: 600,
        margin: '0.2rem',
        padding: '0.25rem 0.6rem',
        borderRadius: 6,
    },
    errorStyle: {
        color: "#c62828",
        fontSize: ".85rem",
        marginTop: 2,
    },
    // shared card wrapper — use on every <Card>
    card: {
        borderRadius: 10,
        overflow: "hidden",
        border: "1.5px solid #c6deca",
        boxShadow: "0 2px 10px rgba(20,50,30,0.06)",
        marginBottom: 0,
    },
    // form field styles
    label: {
        display: "block",
        fontSize: "0.75rem",
        fontWeight: 700,
        color: "#5a6e61",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginBottom: 4,
    },
    select: {
        width: "100%",
        height: 38,
        marginBottom: "1.25rem",
        borderRadius: 7,
        border: "1.5px solid #c6deca",
        padding: "0 0.75rem",
        fontSize: "0.88rem",
        color: "#1a2e22",
        backgroundColor: "#ffffff",
        outline: "none",
    },
    selectDisabled: {
        width: "100%",
        height: 38,
        marginBottom: "1.25rem",
        borderRadius: 7,
        border: "1.5px solid #e0ece4",
        padding: "0 0.75rem",
        fontSize: "0.88rem",
        color: "#5a6e61",
        backgroundColor: "#f4f8f5",
        outline: "none",
    },
    textarea: {
        width: "100%",
        borderRadius: 7,
        border: "1.5px solid #c6deca",
        padding: "0.5rem 0.75rem",
        fontSize: "0.88rem",
        color: "#1a2e22",
        resize: "vertical",
        outline: "none",
        marginBottom: "0.25rem",
    },
    textareaDisabled: {
        width: "100%",
        borderRadius: 7,
        border: "1.5px solid #e0ece4",
        padding: "0.5rem 0.75rem",
        fontSize: "0.88rem",
        color: "#5a6e61",
        backgroundColor: "#f4f8f5",
        resize: "none",
        outline: "none",
        marginBottom: "0.25rem",
    },
};
